module.exports = __webpack_public_path__ + "static/img/graduate-recruitment-experience-ven.015aec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/graduate-recruitment-experience-ven.png
// module id = z6XA
// module chunks = 0